import { render, staticRenderFns } from "./PaymentStatusWidget.vue?vue&type=template&id=aa0be54e&"
import script from "./PaymentStatusWidget.vue?vue&type=script&lang=js&"
export * from "./PaymentStatusWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports